var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pl-0 pr-0",staticStyle:{"max-width":"450px"},attrs:{"fluid":""}},[(_vm.permiteAcao({ path: '/relatorios/gecom-home/' }))?_c('GecomMobile'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }